"use client";

import type { ToolUIRegistry } from "@bg-bgi/magnus-sdk/react";
import { lazy } from "react";

export const multipleChoiceToolRegistry = {
  multipleChoice: {
    kind: "standalone",
    category: "message",
    view: lazy(() =>
      import("./multiple-choice").then(({ MultipleChoiceToolView }) => ({
        default: MultipleChoiceToolView,
      }))
    ),
  },
} satisfies ToolUIRegistry;
